"use client"
import {Chevron} from "@areahub/icons";
import { Icon, IconProps } from "@chakra-ui/react";
import { motion } from "framer-motion";

export interface AnimatedCarrotProps extends IconProps {
  yMovement: number;
}

/**
 * Carat that points down and performs onClickArrow on click
 */
const AnimatedCaratDown = ({ yMovement, ...props }: AnimatedCarrotProps) => {
  return (
    <motion.div
      animate={{ y: yMovement }}
      transition={{
        repeat: Infinity,
        repeatType: "mirror",
        repeatDelay: 1,
        duration: 1,
        ease: "anticipate",
      }}
    >
      <Icon as={Chevron} {...props} />
    </motion.div>
  );
};
export default AnimatedCaratDown;
